import React, { Component } from 'react'
import logo from './assets/img/logo.svg'
import icon_tw2 from './assets/img/icon_tw2.png'
import icon_fb2 from './assets/img/icon_fb2.png'

class Bg extends Component {

  state= {
    color1: "bg-layer color-1 on",
    color2: "bg-layer color-2",
    color3: "bg-layer color-3",
    color4: "bg-layer color-4"
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }
  
  componentWillUnmount(){
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = (e) => {
    if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
      this.setState({color2:'bg-layer color-2 on', color1:"bg-layer color-1"})

  } else {
    this.setState({color1:'bg-layer color-1 on',color2:'bg-layer color-2', color3:"bg-layer color-1"})
  }
  }

  render() {
    return (
      <div>
      <div className="bg-grad">
      <div className="clouds">
        <div className="cloud x1"></div>
      </div>
      <div className={this.state.color1}></div>
      <div className={this.state.color2}></div>
      <div className={this.state.color3}></div>
      <div className={this.state.color4}></div>
    </div></div>
    );
  }
}

export default Bg;



// WEBPACK FOOTER //
// ./src/components/Bg.js